import React,{ Component } from 'react';
import {
  Row,
  Col,
  FormGroup,
  Label,
  Input
} from 'reactstrap';

import Form from '../../../shared/components/Form';
import Button from '../../../shared/components/Button';
import DroppableFileInput from '../../../shared/components/DroppableFileInput';

class EditSuperUser extends Component {
  constructor(){
    super();

    this.state = {
      avatarId:null,
      avatarURL:null,
      avatarThumbnailURL:null
    };
  }

  componentDidMount(){
    if(this.props.needsLoading && !this.props.isCreate && !this.props.isProfile){
      this.props.loadUser(this.props.superuserId);
    }
  }

  handleSubmit(data){
    if(this.state.avatarId){
      data.avatarFileName = this.state.avatarFileName;
      data.avatarId = this.state.avatarId;
      data.avatarURL = this.state.avatarURL;
      data.avatarThumbnailURL = this.state.avatarThumbnailURL;
    }

    if(this.props.isCreate){
      this.props.checkIfEmailTaken(data.email)
        .then((res) => this.props.createProvider(data))
        .then((res) => this.handleSuccess(data))
        .catch((err) => this.handleFailure(err));
    } else if(this.props.isUpdate){
      this.props.updateUser(this.props.superuserId,data)
        .then((res) => this.handleSuccess(data))
        .catch((err) => this.handleFailure(err));
    } else if(this.props.isProfile){
      this.props.updateUser(this.props.activeSuperUserId,data)
        .then((res) => this.handleSuccess(data))
        .catch((err) => this.handleFailure(err));
    }
  }

  handleSuccess(data){
    if(this.props.isProfile){
      this.props.history.push('/superadmin/accounts');
    } else {
      this.props.history.push('/superadmin/superusers');
    }
  }

  handleFailure(err){}

  handlePictureChange(res){
    this.setState({
      avatarId:res.id,
      avatarURL:res.medium,
      avatarThumbnailURL:res.thumbnail,
      avatarFileName:res.fileName
    });
  }

  getSubmitButtonText(){
    if(this.props.isCreate){
      return 'Invite';
    } else if(this.props.isProfile){
      return 'Update';
    } else {
      return 'Update';
    }
  }

  getTitle(){
    if(this.props.isCreate){
      return 'Invite SuperUser';
    } else if(this.props.isProfile){
      return 'My Profile';
    } else {
      return 'Update SuperUser';
    }
  }

  getBackURL(){
    if(this.props.isCreate){
      return '/superadmin/superusers';
    } else if(this.props.isProfile){
      return '/superadmin/accounts';
    } else {
      return '/superadmin/superusers';
    }
  }

  render(){
    const {isCreate,isProfile,existingSuperuser,needsLoading} = this.props,
      formReady = isCreate || (isProfile && !!existingSuperuser) || (!needsLoading && !!existingSuperuser);

    return (
      <div>
        <Row>
          <Col xs='6'>
            <h1 style={{padding:'50px 0px'}}>{this.getTitle()}</h1>
          </Col>
        </Row>
        <Row>
          <Col xs='12' md='6'>
            {formReady ? (
              <Form
                key={existingSuperuser ? existingSuperuser.id : '__create__'}
                onSubmit={(data) => this.handleSubmit(data)}
              >
                <Row>
                  <Col xs='6'>
                    <br />
                    <FormGroup>
                      <Label>First Name</Label>
                      <Input
                        name='firstName'
                        placeholder='John'
                        defaultValue={isCreate ? '' :existingSuperuser.firstName}
                        required
                      />
                    </FormGroup>
                  </Col>
                  <Col xs='6'>
                    <br />
                    <FormGroup>
                      <Label>Last Name</Label>
                      <Input
                        name='lastName'
                        placeholder='Doe'
                        defaultValue={isCreate ? '' :existingSuperuser.lastName}
                        required
                      />
                    </FormGroup>
                  </Col>
                </Row>
                <Row>
                  <Col xs='12'>
                    <FormGroup>
                      <FormGroup>
                        <Label>Email</Label>
                        <Input
                          name='email'
                          type='email'
                          placeholder='jdoe@company.com'
                          defaultValue={isCreate ? '' :existingSuperuser.email}
                          disabled={!isCreate}
                          required
                        />
                      </FormGroup>
                    </FormGroup>
                  </Col>
                </Row>
                {isProfile && (
                  <Row>
                    <Col xs='12'>
                      <DroppableFileInput 
                        label='Profile Picture'
                        fileType='image'
                        name='avatar'
                        text='Upload profile picture'
                        onChange={(res) => this.handlePictureChange(res)}
                        warning={''}
                        cropperAspectRatio={1/1}
                        existingFileName={existingSuperuser.avatarFileName}
                        existingFileURL={existingSuperuser.avatarURL}
                      />
                    </Col>
                  </Row>
                )}
                <br />
                <div className='clearfix'>
                  <Button isSubmit>
                    {this.getSubmitButtonText()}
                  </Button>
                  <Button
                    linkHref={this.getBackURL()}
                    className='pull-right'
                    textColor='#666666'
                    borderColor='#cccccc'
                    backgroundColor='#ededed'
                  >
                    Cancel
                  </Button>
                </div>
              </Form>
            ) : (
              <div>Loading...</div>
            )}
          </Col>
        </Row>
      </div>
    )
  }
}

export default EditSuperUser;



// WEBPACK FOOTER //
// ./src/routes/EditSuperUser/components/EditSuperUser.js